import TypeHelper from './TypeHelper.js';
import NumberHelper from './NumberHelper.js';
import StringHelper from './StringHelper.js';

const ArrayHelper = (function() {

    /**
     * Verifica se o array não é nulo e possui algum item.
     * @param {any[]} list Array que será analisado.
     * @returns {boolean} Se o array não é nulo e possui algum item.
     */
    const IsNullOrEmpty = (list) => {
        return (
            !Array.isArray(list)
            || list.length < 1
        );
    };

    /**
     * Remove um item de uma posição específica de um array.
     * @public
     * @function
     * @param {any[]} list Array que será analisado.
     * @param {number} position Posição do item a ser removido.
     * @returns {any[]} Array sem o item removido.
     */
    const RemoveAt = (list, position) => {

        if ( IsNullOrEmpty(list) ) return [];

        position = NumberHelper.ToNumber(position, true);

        if ( 
            NumberHelper.IsNegative(position) 
            || position >= list.length
        ) {
            return list;
        }

        const start = 0;
        const end = list.length - 1;

        switch (position) {

            case start:
                return list.slice(1);

            case end:
                return list.slice(0, end);

            default:
                return list.slice(0, position).concat(list.slice(position + 1));
        }
    };

    const Sum = (list, selector) => {

    };

    const _helper = {
        IsNullOrEmpty: IsNullOrEmpty,
        RemoveAt: RemoveAt,
    };

    return Object.freeze(_helper);

})();

export default ArrayHelper;